import {Component, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {OPTIONS_POSITION} from "../options/options.component";

export enum DROPDOWN_TYPES {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  DANGER = 'danger'
}
export enum DROPDOWN_STYLES {
  FILLED = 'filled',
  STROKE = 'stroke',
  TEXT = 'text'
}
export enum DROPDOWN_ALIGNMENT {
  LEFT = 'text-left',
  CENTER = 'text-center',
  RIGHT = 'text-right'
}

@Component({
  selector: 'beaconstac-dropdown',
  templateUrl: './dropdowns.component.html',
  styleUrls: ['./dropdowns.component.scss']
})
export class DropdownsComponent {

  DROPDOWN_ALIGNMENT = DROPDOWN_ALIGNMENT;
  DROPDOWN_STYLES = DROPDOWN_STYLES;
  /**
   * Dropdown style
   */
  @Input()
  style: DROPDOWN_STYLES = DROPDOWN_STYLES.FILLED;

  /**
   * Dropdown type
   */
  @Input()
  type: DROPDOWN_TYPES = DROPDOWN_TYPES.PRIMARY;

  /**
   * Dropdown Alignment
   */
  @Input()
  alignment: DROPDOWN_ALIGNMENT = DROPDOWN_ALIGNMENT.LEFT;

  /**
   * Title for dropdown
   */
  @Input()
  title: string;

  /**
   * Dropdown caret should be visible or not
   */
  @Input()
  showCaret = true;

  /**
   * If icon is required on dropdown
   */
  @Input()
  iconClass = '';

  /**
   * Dropdown contents
   */
  @Input()
  listItems = [];

  isListOpen = false;

  /**
   * Value event emitter
   */
  @Output()
  valueChange = new EventEmitter<string>();

  /**
   * In case custom object array is used
   */
  @Input()
  isCustomObjectArray: boolean;

  /**
   * label field from custom object
   */
  @Input()
  optionLabelField: string;

  /**
   * value field from custom object
   */
  @Input()
  optionValueField: string;

  /**
   * Disable dropdown
   */
  @Input()
  disabled: boolean = false;

  /**
   * Show Icon and Title
   */
  @Input()
  showIconAndTitle: boolean = false;

  dropdownOptionsPosition: OPTIONS_POSITION;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const activeDropdown = document.querySelectorAll('.dropdown-options.active');
    const allDropDowns = document.querySelectorAll('.dropdown-toggle');

    if (event.target && !event.target['id'] && activeDropdown.length > 0) {
      activeDropdown[0].classList.remove('active');

      for (let i = 0; i < allDropDowns.length; i++) {
        allDropDowns[i].classList.remove('rotate-caret');
      }
    }
  }

  toggleOptions(_this) {
    this.isListOpen = !this.isListOpen;
    const activeDropdown = document.querySelectorAll('.dropdown-options.active');
    if (activeDropdown.length > 0 && activeDropdown[0].id == _this.title) {
      document.getElementById(_this.title).classList.remove('active');
      document.getElementById(_this.title + '-btn').classList.remove('rotate-caret');
      return;
    }

    if (activeDropdown.length > 0) {
      activeDropdown[0].classList.remove('active');
      const allDropDowns = document.querySelectorAll('.dropdown-toggle');
      for (let i = 0; i < allDropDowns.length; i++) {
        allDropDowns[i].classList.remove('rotate-caret');
      }
    }

    setTimeout(() => {
      document.getElementById(_this.title).classList.toggle('active');
      if (!this.isInViewport(document.getElementById(_this.title))) {
        this.dropdownOptionsPosition = OPTIONS_POSITION.TOP;
      }
    }, 100);
    document.getElementById(_this.title + '-btn').classList.toggle('rotate-caret');
  }

  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top - 10 >= 0 &&
      rect.left - 10 >= 0 &&
      rect.bottom + 200 <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right + 200 <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  setValue(val) {
    this.valueChange.emit(val);
  }

}
